import { render, staticRenderFns } from "./AdsWrapper.vue?vue&type=template&id=b3b8618e&scoped=true&"
import script from "./AdsWrapper.vue?vue&type=script&lang=ts&"
export * from "./AdsWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b8618e",
  null
  
)

export default component.exports